import slides from '../api/profileStrengthData';

const getIds = () => slides.map(s => s.id);

const getProfileStrengthMissingIds = data => {
    const allIds = getIds();
    const positiveIds = getProfileStrengthIds(data);
    const missingIds = allIds.filter(id => positiveIds.includes(id));
    return missingIds;
};

/**
 * @param {Object} data
 * @param {string} data.photoUrl
 * @param {string} data.twitterUrl
 * @param {string} data.linkedinUrl
 * @param {string} data.blogUrl
 * @param {string} data.functionalTitle - title category shortened, just checking if present
 * @param {string} data.description - About statement
 * @param {Object} data.firstCollege - code & name
 */
const getProfileStrengthIds = data => {
    const { photoUrl, twitterUrl, linkedinUrl, blogUrl, functionalTitle, description, firstCollege, noCollege } = data;
    const ids = [];

    // has profile photo
    if (photoUrl) {
        ids.push('image');
        // console.log('has photo', score);
    }

    // has social media link
    if (twitterUrl || linkedinUrl || blogUrl) {
        ids.push('social');
        // console.log('has social', score);
    }

    // has title category
    if (functionalTitle) {
        ids.push('title');
        // console.log('has functionalTitle', score);
    }

    // has about statement
    if (description) {
        ids.push('bio');
        // console.log('has description', score);
    }

    // has education
    if (noCollege || (firstCollege && firstCollege.name)) {
        ids.push('education');
        // console.log('has education', score);
    }

    return ids;
};

export const getProfileStrengthPercent = data => {
    // 16.66
    const interval = parseFloat((100 / slides.length).toFixed(2));
    const ids = getProfileStrengthIds(data);
    return ids.length * interval;
};

export const getProfileStrengthText = percent => {
    // 5
    if (percent > 80) {
        return 'Strong';
    }
    // 3-4
    if (percent > 50) {
        return 'Intermediate';
    }
    // <= 2
    return 'Weak';
};

export const getSlides = data => {
    const missingIds = getProfileStrengthMissingIds(data);
    return slides.filter(s => !missingIds.includes(s.id));
};
